import { ResourceStatus } from "@app/resources";
import { ServiceBase } from "@app/shared";
import { ImportBulkTargetingFileResponseModel, BulkTargetingApiResponseModel , BulkCreateProviderTargetingModel } from "@app/targeting/import/interfaces";
import { ProjectionProviderHistory } from "../results/projection-provider/projectionProviderHistory";

export default class ProjectionProviderService extends ServiceBase {
  public async getProjectionProviderHistory(projectionProviderProjectId: number, projectionProviderSettingsId: number): Promise<ProjectionProviderHistory> {
    return await this.makeGet(`projectionproviders/${projectionProviderProjectId}/projectionhistory/${projectionProviderSettingsId}`);
  }

  public async getBulkTargetingProjectsAsync(
    includeShared = true,
    includeHidden = false,
    resourceStatus: ResourceStatus = ResourceStatus.Active
  ): Promise<BulkTargetingApiResponseModel[]> {
    return await this.makeGet("projectionproviders/bulktargetingprojects", { includeHidden, includeShared, resourceStatus });
  }

  public async importBulkTargetFile(bulkTargetingFile: FormData): Promise<ImportBulkTargetingFileResponseModel> {
    return await this.makePost<ImportBulkTargetingFileResponseModel>(`projectionproviders/importbulktargetingfile`, bulkTargetingFile, undefined, true, false, false);
  }

  public async bulkCreateProviderTargeting(bulkCreateProviderTargetingModel: BulkCreateProviderTargetingModel): Promise<void> {
    return await this.makePost(`projectionproviders/bulkcreatetargets`, bulkCreateProviderTargetingModel);
  }


  public async getProviderTargetingReasons(): Promise<string[]> {
    return await this.makeGet(`projectionproviders/providertargetingreasons`);
  }
}